import React, { useState } from "react";
import {
    DropdownToggle,
    DropdownMenu,
    Nav,
    NavItem,
    NavLink,
    UncontrolledButtonDropdown,
} from "reactstrap";

import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Auth from "../../../services/Auth";
import { setUserRole } from "reducers/UserPermission";
import { setUserProfilePicture } from "reducers/UserProfile";
import AuthService from "Api/Auth";
import { setSubMenuClass } from "reducers/ThemeOptions";
import axiosInstance from "Api";
import { toast } from "react-toastify";

const UserBox = () => {

    const user = Auth.getAuthenticatedUser();
    const profileImage = useSelector(state => state.UserProfile.profileImage);
    const userRoles = useSelector((state) => state.UserPermission);
    const dispatch = useDispatch();
    let navigate = useNavigate();
    const [colorDropdown, setColorDropdown] = useState(false);

    const impersonate = () => {
        setColorDropdown(false);
        dispatch(setSubMenuClass(' hidden-submenu '));
        axiosInstance.get('/logout-impersonate-user').then((response) => {

            if (response.data.status === "success") {
                if (response.data?.roles.length !== 0 && response.data?.roles[0] !== "") {
                    const roles = AuthService.applySessionRoles(response.data);
                    dispatch(setUserRole(roles));
                    dispatch(setUserProfilePicture(response.data.user.profileImage));
                    Auth.setAuthenticatedUser(response.data.user);
                    localStorage.removeItem("IS_IMPERSONATE");
                    navigate('/beheerder/gebruikers');
                } else {
                    toast["warning"]("Gebruiker heeft geen rol!")
                }
            }
        }).catch(() => console.error);
    }

    const handleLogout = () => {
        const isImpersonated = localStorage.getItem("IS_IMPERSONATE");

        isImpersonated ? impersonate() : Auth.logout()
            .then((res) => {
                if (res?.status === 200) {
                    setColorDropdown(false);
                    localStorage.clear();
                    navigate("/login");
                }
            }
            ).catch(() => console.error)
    };

    return (
        <>
            <div className="header-btn-lg pe-0 profile-dropdown">
                <div className="widget-content p-0">
                    <div className="widget-content-wrapper">
                        <div className="widget-content-left">
                            <UncontrolledButtonDropdown isOpen={colorDropdown} toggle={() => setColorDropdown((prev) => !prev)}>
                                <DropdownToggle color="link" className="p-0 d-flex align-items-center profile-toggle">
                                    <img className="rounded-circle profile-pic" src={profileImage} alt="" />
                                    <FontAwesomeIcon className="ms-2 opacity-8" icon={faAngleDown} />
                                </DropdownToggle>
                                <DropdownMenu end className="rm-pointers dropdown-menu-lg">
                                    <div className="dropdown-menu-header border-bottom">
                                        <div className="dropdown-menu-header-inner">
                                            <div className="menu-header-content text-start">
                                                <div className="widget-content p-0">
                                                    <div className="widget-content-wrapper">
                                                        <div className="widget-content-left me-3">
                                                            <img width={42} height={42} className="rounded-circle profile-pic" src={profileImage} alt="" />
                                                        </div>
                                                        <div className="widget-content-left text-body">
                                                            <div className="widget-heading">
                                                                {user?.vFirstName} {user?.vMiddleName} {user?.vLastName}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <Nav vertical>
                                        <NavItem className="menu-sub-items">
                                            <NavLink href="#" onClick={() => {
                                                navigate("/profiel", { state: { from: "header-profile" } });
                                            }}>
                                                <i className="nav-link-icon pe-7s-user"> </i>
                                                <span>Profiel</span>
                                            </NavLink>
                                        </NavItem>

                                        {/* <NavItem>
                                            <NavLink href="#" onClick={() => {
                                                navigate("/profiel", { state: { from: "header-password" } });
                                            }}>
                                                <i className="nav-link-icon pe-7s-key"> </i>
                                                <span>Wachtwoord wijzigen</span>
                                            </NavLink>
                                        </NavItem>

                                        <NavItem>
                                            <NavLink href="#" onClick={() => {
                                                navigate("/profiel", { state: { from: "header-2fa" } });
                                            }}>
                                                <i className="nav-link-icon pe-7s-shield"> </i>
                                                <span>Twee-factor-authenticatie (2fa)</span>
                                            </NavLink>
                                        </NavItem> */}

                                        <NavItem className="nav-item-divider" />

                                        <NavItem className="menu-sub-items">
                                            <NavLink href="#" onClick={handleLogout}>
                                                <span>Uitloggen</span>
                                            </NavLink>
                                        </NavItem>

                                    </Nav>
                                </DropdownMenu>
                            </UncontrolledButtonDropdown>
                        </div>
                        <div className="widget-content-left  ms-3 header-user-info">
                            <div className="widget-subheading">{user?.vFirstName} {user?.vMiddleName} {user?.vLastName}</div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

}

export default UserBox; 